<template>
  <div class="home h-100">
    <div class="page-index">
      <app-banner />
      <div class="last-courses mt-5">
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="subject">
                <header class="text-right">
                  <i class="flaticon-note icon-20"></i>
                  <h3>{{$t('title.lastCourse')}}</h3>
                </header>
              </div>
              <listCourses :items="lastCourse" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="subject">
          <header class="text-right">
            <i class="flaticon-list icon-22"></i>
            <h3>مهندسی عمران</h3>
          </header>
        </div>
        <div class="row">
          <div class="col-12">
            <MTab :tabs="categories" @onClick="filterBySubCat" label="subcategory" />
          </div>
          <div class="col-12 mt-2">
            <listCourses :items="filterList" />
          </div>
        </div>
      </div>
      <div class="whay-madya">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <header class="py-5 text-center">
                <h2 class="font-20 pb-2 px-3 d-inline-block">مادیا چگونه کار می کند؟</h2>
              </header>
            </div>
            <div class="col-12 col-md-6">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="box panel-card d-flex flex-column text-center py-3">
                      <i class="flaticon-objective icon-35 py-1"></i>
                      <h3 class="font-18 py-2">هدف</h3>
                      <p
                        class="py-2 font-14"
                      >از یک متخصص به یک مدرس تبدیل شوید، در دانش و تخصصی که دارید شناخته شوید. شما می‌توانید هرچیزی را که دوست دارید، آموزش دهید.</p>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="box panel-card d-flex flex-column text-center py-3">
                      <i class="flaticon-video-camera icon-35 mdi py-1"></i>
                      <h3 class="font-18 py-2">ایجاد</h3>
                      <p
                        class="py-2 font-14"
                      >به آسانی با استفاده از ابزار های طراحی رایگان، دروه آنلاین خود را ایجاد نمایید.</p>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="box panel-card d-flex flex-column text-center py-3">
                      <i class="flaticon-tutorial icon-35 py-1"></i>
                      <h3 class="font-18 py-2">آموزش</h3>
                      <p
                        class="py-2 font-14"
                      >به میلیون ها مخاطب در بزرگترین بازار آموزش کشور دسترسی داشته باشید و دوره خود را بر روی هر دستگاه، در هر زمان ارائه نمایید.</p>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="box panel-card d-flex flex-column text-center py-3">
                      <i class="flaticon-money icon-35 mdi py-1"></i>
                      <h3 class="font-18 py-2">درآمد</h3>
                      <p
                        class="py-2 font-14"
                      >بطور جدی کسب درآمد کنید، برند شخصی خودتان را بسازید و یک تغییر واقعی در زندگی مخاطبین ایجاد نمایید.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 align-items-center d-flex">
              <div class="col-12">
                <div class="video-for-madya">
                  <video controls poster="/static/img/poster.png">
                    <source src="/static/video/how-work-madya.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-blog-slider my-5">
        <div class="container">
          <div class="subject">
            <header class="text-right">
              <i class="flaticon-comment icon-22"></i>
              <h3>مقالات مادیا</h3>
            </header>
          </div>
          <div class="row">
            <div class="col">
              <m-blog-slider />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppBanner from "cp/banner.vue";
import listCourses from "cp/list-courses-slider.vue";
import MBlogSlider from "cp/blog/slider.vue";

import MTab from "cp/element/tab";
export default {
  components: {
    MTab,
    AppBanner,
    listCourses,
    MBlogSlider
  },
  computed: {
    lastCourse() {
      return this.$store.state.courses.lastCourse;
    },
    filterList() {
      return this.$store.state.courses.someCatsListCourse;
    },
    categories() {
      let item = [...this.$store.state.categories.categories];
      if (!item) return [];
      return item.filter(
        e => e.category === "مهندسی عمران" || e.category === "دوره های تعاملی"
      );
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch("courses/getLastCourse");
    this.filterBySubCat({ page_num: 1, subcategory_id: 1 });
  },
  methods: {
    filterBySubCat({ page_num, subcategory_id }) {
      this.$store.dispatch("courses/getByCat", {
        page_num,
        id: subcategory_id
      });
    }
  }
};
</script>

<style lang="less">
@import (reference) "../assets/css/variable.less";

.home {
  .video-for-madya {
    video {
      width: 100%;
    }
  }
  .whay-madya {
    padding: 25px 0;
    background-color: #fff;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.25);

    h2 {
      color: @primaryTextColor;
      .line;
    }
    .box {
      min-height: 230px;
      background-color: #eef0f5;

      p {
        height: 80px;
      }
      i {
        height: 60px;
        color: #5d5c5c;
      }
    }
  }
}
.page-index {
  .last-courses {
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue